module.exports = __webpack_public_path__ + "static/media/oediv-1x.dc3474ab.jpg";